var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskProgress1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1112,
    height: 938,
    viewBox: "0 0 1112 938",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1112,
    height: 938,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 535C60 532.791 61.7978 530.974 63.9897 531.25C69.5074 531.943 74.7741 534.066 79.2528 537.44C84.8013 541.619 88.8392 547.49 90.7567 554.167C92.6742 560.843 92.3671 567.963 89.8817 574.449C87.3964 580.936 82.8678 586.437 76.98 590.123C71.0921 593.809 64.1648 595.479 57.2442 594.881C50.3235 594.283 43.7855 591.449 38.6175 586.807C33.4495 582.166 29.9322 575.968 28.5969 569.152C27.519 563.649 27.91 557.984 29.6969 552.718C30.4067 550.626 32.8262 549.802 34.8134 550.767V550.767C36.8005 551.733 37.5932 554.122 36.9711 556.242C35.8926 559.917 35.7039 563.817 36.4476 567.614C37.4492 572.726 40.0871 577.374 43.9631 580.856C47.8391 584.337 52.7427 586.462 57.9331 586.911C63.1236 587.36 68.3191 586.107 72.735 583.343C77.1509 580.578 80.5473 576.452 82.4113 571.587C84.2753 566.722 84.5056 561.383 83.0675 556.375C81.6294 551.368 78.601 546.964 74.4396 543.83C71.3493 541.502 67.7588 539.968 63.9816 539.333C61.8031 538.966 60 537.209 60 535V535Z",
    fill: "#E39F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3484 569.348L66.3484 557.348",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3484 559.348L54.3484 569.348L64.3484 569.348",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskProgress1);
export default __webpack_public_path__ + "static/media/task-progress-1.899bbf1887e96c0a7039ec09779e61f7.svg";
export { ForwardRef as ReactComponent };